import { Component, OnInit } from '@angular/core';
import { UpgradeModule } from '@angular/upgrade/static';
import { MODULE_NAME } from '../../old-crazy-web-frontend/src/app';
import { SentryService } from './config/sentry.service';
import { TranslateService } from '@ngx-translate/core';
import { LeftMenuComponent } from './main/left-menu/left-menu.component';
import { ConfigService } from './config/config.service';
import { Ng1TranslateService } from './shared/ng1-translate.service';
import { CalendlyService } from './config/calendly.service';
import { TypeformService } from './shared/services/typeform.service';
import { LanguageService } from './shared/services/language.service';
import { getUserDetailsSelector } from './shared/user/user.reducer';
import { Store } from '@ngrx/store';
import { IState } from './shared/models/state';
import * as moment from 'moment';
import * as localEn from '../assets/i18n/locale_en.json';
import * as localEs from '../assets/i18n/locale_es.json';
import { AlertPaymentService } from './shared/services/alert-payment.service';
import { environment } from '../environments/environment';
import { AmplitudeRouteListenerService } from 'app/shared/services/amplitude-route-listener.service';
import { PaymentParams } from './account/account.model';

@Component({
  selector: 'cc-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public leftMenuComponent = LeftMenuComponent;
  public failPaid = false;
  public payment: PaymentParams;
  public progressColor: string;
  private $state: any;

  constructor(
    private upgrade: UpgradeModule,
    private translateService: TranslateService,
    private sentryService: SentryService,
    private configService: ConfigService,
    private ng1TranslateService: Ng1TranslateService,
    private calendlyService: CalendlyService,
    private survicateService: TypeformService,
    private languageService: LanguageService,
    private store: Store<IState>,
    private alertPaymentService: AlertPaymentService,
    private amplitudeRouteListenerService: AmplitudeRouteListenerService
  ) {}

  ngOnInit() {
    this.isChannelsDomain();
    this.replaceFavicon();
    this.progressColor = this.isChannelsDomain() ? '#23D99C' : 'red';
    this.sentryService.setInitialParams();
    this.calendlyService.initCalendly();
    this.survicateService.initTypeform();
    this.upgrade.bootstrap(document.body, [MODULE_NAME], { strictDi: true });
    this.$state = this.configService.getValue('$state');
    this.translateService.setDefaultLang('en');
    const selectedLanguage = this.languageService.selectLanguageBasedOnBrowserSettings();
    this.alertPaymentService.onActivatePaymentAlert.subscribe(isPaymentFailed => {
      this.failPaid = isPaymentFailed;
    });
    this.alertPaymentService.onPaymentParamsFetch.subscribe(payment => {
      this.payment = payment;
    });

    this.amplitudeRouteListenerService.startListening();

    this.store.select(getUserDetailsSelector).subscribe(details => {
      if (details && details.language) {
        this.fetchTranslations(details.language);
      } else {
        this.fetchTranslations(selectedLanguage);
      }
    });
  }

  isChannelsDomain(): boolean {
    return document.location.origin === environment.CHANNELS_URL || document.location.hostname.startsWith('localhost');
  }

  fetchTranslations(lng) {
    this.translateService.setTranslation('en', localEn);
    this.translateService.setTranslation('es', localEs);

    this.ng1TranslateService.setLang('en', localEn, lng);
    this.ng1TranslateService.setLang('es', localEs, lng);

    // if (environment.INTERNATIONALIZATION_URL) {
    //   forkJoin([this.languageService.getTranslation('en'), this.languageService.getTranslation('es')]).subscribe(
    //     ([en, es]: any) => {
    //       this.translate.setTranslation('en', en);
    //       this.translate.setTranslation('es', es);
    //
    //       this.ng1TranslateService.setLang('en', en, lng);
    //       this.ng1TranslateService.setLang('es', es, lng);
    //     }
    //   );
    // }

    this.translateService.setDefaultLang('en');
    this.useLanguage(lng);
  }

  isVisibleMenu() {
    return (
      this.$state && this.$state.current && this.$state.current.name && !this.$state.current.name.startsWith('accounts')
    );
  }

  useLanguage(lang) {
    this.ng1TranslateService.use(lang);
    this.languageService.use(lang);
    moment.locale(lang);
  }

  public get directPayment() {
    try {
      return this.payment && this.payment.directPayment;
    } catch (e) {
      return false;
    }
  }

  replaceFavicon() {
    const faviconElement = document.getElementById('favicon');
    const appleTouchIcon = document.getElementById('apple-touch-icon');
    const pageTitle = document.getElementById('page-title');
    const iconUrl = this.isChannelsDomain() ? '/assets/img/channels/favicon.png' : '/assets/img/favicon.png';

    faviconElement.setAttribute('href', iconUrl);
    appleTouchIcon.setAttribute('href', iconUrl);
    pageTitle.innerText = this.isChannelsDomain() ? 'Channels' : 'CrazyCall';
  }
}
